<template>
    <div>
        <header>
            <div class="banner">
                <van-row>
                    <van-col span="6" @click="back"><img class="back-icon" src="@/assets/share/home/back.png"></van-col>
                    <van-col span="12">
                        <div class="banner-title">消息</div>
                    </van-col>
                    <van-col span="6" @click="deleteMsg">
                        <div class="clear">清空</div>
                    </van-col>
                </van-row>
            </div>
        </header>
        <div class="content-body">
            <div class="content">
                <div class="item" v-for="(item, i) in unReadList" @click="toDesc(item)">
                    <img class="user-img" :src="item.userAvatar ? item.userAvatar : defaultImg">
                    <div class="user-name">{{item.userNameRemark ? item.userNameRemark : item.userName}}</div>
                    <div class="msg" v-if="item.type != 2"><span class="return" v-if="item.type==1">回复：</span>{{item.content}}
                    </div>
                    <van-icon name="like-o" class="like" v-if="item.type == 2"/>
                    <div class="time">{{getDateDiff(item.createTime)}}</div>
                    <div class="chart-box" v-if="getType(item) == 0">
                        <div class="value">{{(item.distance / 100000).toFixed(2)}}</div>
                        <div class="unit">公里</div>
                    </div>
                    <div class="chart-box" v-if="getType(item) == 1">
                        <div class="value">{{parseInt(item.calories / 1000)}}</div>
                        <div class="unit">千卡</div>
                    </div>
                    <div class="chart-box" v-if="getType(item) == 2" :id="i">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {getDateDiff} from '@/utils/dateUtils';
    import {Dialog, Toast} from 'vant';

    export default {
        name: 'unReadList',
        data() {
            return {
                defaultImg: require('@/assets/share/home/noImg.png'),
                unReadList: [],
                pageSize: 10,
                pageNum: 0,
                isLoading: false,
            }
        },
        mounted() {
            this.getUnreadList();
            this.bindScroll();
        },
        methods: {
            back() {
                this.$router.back();
            },
            getUnreadList() {
                this.pageNum++;
                this.isLoading = true;
                this.$api.share.getUnread({
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                }).then(res => {
                    this.isLoading = false;
                    this.unReadList.push(...res.info.items);
                    for (let i = 0; i < this.unReadList.length; i++) {
                        if (this.unReadList[i].ecgId) {
                            this.$nextTick(function () {
                                this.drawEcg(this.unReadList[i], i)
                            })
                        }
                    }
                })
            },
            deleteMsg() {
                let _this = this;
                Dialog.confirm({
                    message: '清空所有消息？',
                    getContainer: "#app",
                    confirmButtonColor: '#20D38F',
                    confirmButtonText: '确认',
                    cancelButtonText: '取消',
                    cancelButtonColor: '#ffffff',
                }).then(() => {
                    this.$api.share.clearMsg().then(res => {
                        Toast({message: '已清空！'});
                        _this.unReadList = [];
                        // _this.pageNum = 0;
                        // _this.getUnreadList();
                    })
                }).catch(() => {
                    // on cancel
                });
            },
            toDesc(item) {
                localStorage.setItem('cSportId', item.sportId ? item.sportId : 0);
                localStorage.setItem('cSportType', item.sportType);
                localStorage.setItem('cSportStartTime', item.startSportTime ? item.startSportTime : 2023);
                localStorage.setItem('cEcgId', item.ecgId ? item.ecgId : 0);
                this.$router.push({
                    name: 'msgDesc'
                })
            },
            getDateDiff(n) {
                return getDateDiff(n)
            },
            getType(item) {
                if (item.ecgId) {
                    return 2
                } else {
                    let sportType = item.sportType;
                    if (sportType == '自由训练' || sportType == '俯卧撑' || sportType == '深蹲' || sportType == '卷腹' || sportType == '平板支撑' || sportType == '椭圆机' || sportType == '划船机' || sportType == '跳绳') {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            },
            drawEcg(item, i) {
                let a = item.ecgFragment;
                let b = a.split(',');
                let c = [];
                for (let i = 0; i < b.length / 2; i++) {
                    c.push(i);
                }
                let myChart = this.$echarts.init(document.getElementById(i));
                myChart.setOption({
                    grid: {
                        top: 0,
                        bottom: 0,
                        left: 10,
                        right: 10
                    },
                    xAxis: {
                        type: 'category',
                        axisLine: {
                            show: false,
                        },
                        axisLabel: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        data: c
                    },
                    yAxis: {
                        type: 'value',
                        position: 'right',
                        axisLabel: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        }
                    },
                    series: [
                        {
                            data: b,
                            type: 'line',
                            symbol: 'none',
                            color: '#DC3D5C',
                            smooth: false,
                            lineStyle: {
                                width: 3
                            }
                        }
                    ]
                }, true);
            },
            // 滚动回调函数
            scrollHande() {
                // 节流
                if (this.isLoading) return
                // 获取内容高度
                var scrollH = document.documentElement.scrollHeight
                // 获取窗口高度
                var innerH = window.innerHeight
                // 获取滚出去的内容高度
                var top = document.body.scrollTop || document.documentElement.scrollTop
                // 当内容还剩余200的高度未滚出的时候发送请求
                if (scrollH - top - innerH < 200) {
                    // 发送请求
                    this.getUnreadList();
                }
            },
            // 绑定scroll事件
            bindScroll() {
                window.addEventListener('scroll', this.scrollHande)
            },
            // 清除scroll事件
            clearScroll() {
                window.removeEventListener('scroll', this.scrollHande)
            },
        },
        // 页面销毁之前，清除scroll
        destroyed() {
            this.clearScroll()
        }
    }
</script>

<style scoped>

    .item {
        width: 345px;
        height: 97px;
        background: #202020;
        opacity: 1;
        border-radius: 6px;
        margin: 10px auto;
        position: relative;
    }

    .user-img {
        width: 40px;
        height: 40px;
        background: #FFFFFF;
        border: 2px solid rgba(255,255,255,0.69);
        border-radius: 50%;
        position: absolute;
        top: 18px;
        left: 20px;
    }

    .user-name {
        font-size: 14px;
        color: #E9E9E9;
        position: absolute;
        top: 18px;
        left: 70px;
        width: 200px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
    }

    .msg {
        position: absolute;
        color: #A5A5A5;
        font-size: 14px;
        left: 70px;
        width: 200px;
        top: 42px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
    }

    .time {
        position: absolute;
        left: 70px;
        top: 71px;
        color: #FFFFFF;
        opacity: 0.6;
        font-size: 12px;
    }

    .chart-box {
        width: 65px;
        height: 65px;
        background: #000000;
        opacity: 1;
        border-radius: 6px;
        position: absolute;
        right: 16px;
        top: 18px;
    }

    .value {
        margin-top: 8px;
        font-size: 24px;
        font-family: Bold;
        text-align: center;
    }

    .unit {
        font-size: 11px;
        color: #A5A5A5;
        opacity: 0.7;
        text-align: center;
    }

    .like {
        width: 24px;
        font-size: 20px;
        color: #A5A5A5;
        position: absolute;
        left: 70px;
        top: 42px;
    }

    .return {
        color: #d5d5d5 !important;
    }

    .clear {
        font-size: 14px;
        color: #E9E9E9;
        float: right;
        margin-top: 14px;
        margin-right: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/views/share/unReadList.vue